window.addEventListener('SITE_START', () => {
  const $header = document.querySelector('#header');
  const $nav = $header.querySelector('#nav');
  const $gnb = $nav.querySelector('.gnb');
  const $submenus = $gnb.querySelectorAll('.submenu');
  const lenis = window.lenis;

  $nav.addEventListener('mouseenter', () => {
    $header.setAttribute('data-status', 'show-submenu');
  });

  $nav.addEventListener('mouseleave', () => {
    $header.setAttribute('data-status', 'hide-submenu');
  });
  function onResize() {
    let submenuMaxHeight = 0;
    $submenus.forEach(($submenu) => {
      const ul = $submenu.querySelector('ul');
      ul.style.height = 'auto';
      const submenuHeight = ul.offsetHeight;
      if (submenuHeight > submenuMaxHeight) {
        submenuMaxHeight = submenuHeight;
      }
      ul.style.height = '';
    });
    $header.style.setProperty('--submenu-height', submenuMaxHeight + 'px');

    // 화면 크기 변경 시 활성 메뉴 상태 다시 설정
    setActiveMenu();
  }
  window.addEventListener('resize', onResize);

  onResize();

  ScrollTrigger.create({
    trigger: '#main',
    start: 'top top',
    end: 'bottom bottom',
    onUpdate: (self) => {
      $header.classList.toggle('--hide', self.direction === 1 && self.scroll() > 100);
    },
    refreshPriority: -1, // 다른 ScrollTrigger보다 나중에 실행
  });

  // 전역 스크롤 방향 감지 (pin이 적용되어도 작동)
  let lastScrollY = window.scrollY;
  let ticking = false;
  //window.addEventListener('scroll', requestTick, { passive: true }); // ahchor_tab 이동 시 불필요한 이벤트 발생 방지
  function updateHeaderOnScroll() {
    const currentScrollY = window.scrollY;
    const scrollDirection = currentScrollY > lastScrollY ? 1 : -1;

    if (scrollDirection === 1 && currentScrollY > 100) {
      $header.classList.add('--hide');
    } else if (scrollDirection === -1) {
      $header.classList.remove('--hide');
    }

    lastScrollY = currentScrollY;
    ticking = false;
  }
  function requestTick() {
    if (!ticking) {
      requestAnimationFrame(updateHeaderOnScroll);
      ticking = true;
    }
  }

  const $utils = $header.querySelector('.utils');
  const $cs = $utils?.querySelector('.utils .cs');
  const $toggle = $cs?.querySelector('.toggle');
  const $notificationPopup = $header.querySelector('.notification-popup');

  $toggle?.addEventListener('mouseenter', () => {
    $notificationPopup?.classList.add('--hide');
  });

  const $toggleNav = $header.querySelector('.toggle-nav');
  $toggleNav?.addEventListener('click', () => {
    $header.classList.toggle('--show-nav');
    onHideSearch();

    // nav 내부만 스크롤 가능하도록 이벤트 제어
    if ($header.classList.contains('--show-nav')) {
      if (lenis) window.lenis.stop();
      $nav.addEventListener('wheel', (e) => e.stopPropagation());
      $nav.addEventListener('touchmove', (e) => e.stopPropagation());
    } else if (lenis) {
      window.lenis.start();
    }
  });

  // 현재 페이지에 해당하는 메뉴 활성화 및 서브메뉴 자동 펼치기
  function setActiveMenu() {
    const currentPath = window.location.pathname;
    const currentHash = window.location.hash;
    const currentFullUrl = currentPath + currentHash;
    const $gnbItems = $gnb.querySelectorAll('li.has-submenu');

    $gnbItems.forEach(($item) => {
      const $depth1Link = $item.querySelector('.depth1');
      const $submenuLinks = $item.querySelectorAll('.submenu a');
      let isActiveMenu = false;

      // 기존 활성 상태 초기화
      $item.classList.remove('--active');
      $submenuLinks.forEach(($link) => $link.classList.remove('--active'));

      // depth1 링크 체크
      if ($depth1Link && $depth1Link.getAttribute('href')) {
        const depth1Href = $depth1Link.getAttribute('href');
        if (currentPath.includes(depth1Href.replace('.do', ''))) {
          isActiveMenu = true;
        }
      }

      // submenu 링크 체크 (해시 포함)
      $submenuLinks.forEach(($submenuLink) => {
        const href = $submenuLink.getAttribute('href');
        if (href) {
          // 현재 URL에 해시가 있는 경우
          if (currentHash) {
            // 해시까지 정확히 일치하는 링크만 active
            if (currentFullUrl === href || currentPath + currentHash === href) {
              isActiveMenu = true;
              $submenuLink.classList.add('--active');
            }
          } else {
            // 현재 URL에 해시가 없는 경우
            if (href.includes('#')) {
              // 해시가 있는 링크는 매칭하지 않음
              // skip
            } else {
              // 일반 URL의 경우 기존 로직 사용
              if (currentPath.includes(href.replace('.do', ''))) {
                isActiveMenu = true;
                $submenuLink.classList.add('--active');
              }
            }
          }
        }
      });

      if (isActiveMenu) {
        $item.classList.add('--active');
        // 모바일에서 서브메뉴 자동으로 펼치기
        if (window.innerWidth < 1361) {
          $item.classList.add('--show-submenu');
        }
      }
    });
  }

  $header.querySelectorAll('.has-submenu .depth1').forEach(($depth1) => {
    $depth1.addEventListener('click', (e) => {
      if (window.innerWidth < 1361) {
        e.preventDefault();
      }
      $depth1.parentElement.classList.toggle('--show-submenu');
    });
  });

  // 페이지 로드 시 활성 메뉴 설정
  setActiveMenu();

  // 해시 변경 시에도 활성 메뉴 상태 업데이트
  window.addEventListener('hashchange', setActiveMenu);

  const $searchBtn = document.querySelector('.btn-search');
  const $searchArea = document.querySelector('.header-search');
  const $searchDim = $searchArea?.querySelector('.header-search__dim');

  $searchBtn?.addEventListener('click', () => {
    if ($searchArea?.classList.contains('--show-search')) onHideSearch();
    else onShowSearch();
  });

  $searchDim?.addEventListener('click', () => onHideSearch());

  function onShowSearch() {
    if (!$searchArea || !$searchBtn) return;
    $header.classList.remove('--show-nav');
    $searchBtn.classList.add('--active');
    $searchArea.classList.add('--show-search');
    $searchArea.querySelector('input').value = '';
    $searchArea.querySelector('input').focus();
    if (lenis) lenis.stop();
  }
  function onHideSearch() {
    if (!$searchArea || !$searchBtn) return;
    $searchBtn.classList.remove('--active');
    $searchArea.classList.remove('--show-search');
    if (lenis) lenis.start();
  }

  // 그룹사 페이지 해시 이동
  const isEnglish = window.location.pathname.startsWith('/en');

  const overviewPath = isEnglish ? '/en/group/overview.do' : '/group/overview.do';
  const $overviewLinks = $header.querySelectorAll(`a[href^="${overviewPath}#"]`);
  $overviewLinks.forEach(($link) => {
    $link.addEventListener('click', (e) => {
      const isGroupOverviewPage = window.location.pathname.includes('/group/overview.do');
      const hash = $link.hash;
      console.log('click');
      if (isGroupOverviewPage) {
        $header.classList.remove('--show-nav');
        window.location.href = overviewPath + hash;
      }
    });
  });

  if ($cs) {
    const $toggle = $cs.querySelector('.toggle');
    window.addEventListener('click', (e) => {
      if (e.target.closest('.toggle') === $toggle) {
        $cs.classList.toggle('--active');
      } else {
        $cs.classList.remove('--active');
      }
    });
  }

  // 언어 전환 기능 국/영
  const $langToggle = $header.querySelector('.lang-toggle');
  if ($langToggle) {
    const $btnKo = $langToggle.querySelector('.__lang.lang-ko');
    const $btnEn = $langToggle.querySelector('.__lang.lang-en');
    const currentUrl = window.location.pathname;

    // 🇰🇷 한국어 버튼 클릭
    $btnKo?.addEventListener('click', (e) => {
      e.preventDefault();
      if (currentUrl.startsWith('/en')) {
        const newUrl = currentUrl.replace(/^\/en/, '') || '/';
        window.location.href = newUrl;
      }
    });

    // 🇺🇸 영어 버튼 클릭
    $btnEn?.addEventListener('click', async (e) => {
      e.preventDefault();

      if (!currentUrl.startsWith('/en')) {
        // 현재 페이지의 영문 지원 여부 체크
        if (currentUrl && currentUrl !== '/') {
          // URL 경로를 번역 파일 경로로 변환
          // 예: /company/introduction.do -> company/introduction
          let translationPath = currentUrl.replace(/^\//, '').replace(/\.do$/, '').replace(/\/$/, '');

          try {
            const response = await fetch(`/assets/js/src/i18n/${translationPath}.json`);
            // 번역 파일이 없는 경우
            if (!response.ok) {
              const confirmed = confirm('영문에서는 지원하지 않는 페이지입니다. 메인으로 이동하시겠습니까?');
              if (confirmed) window.location.href = '/en/';

              return;
            }
          } catch (error) {
            console.warn('[i18n] Error checking translation file:', error);
          }
        }

        // 영문 지원 페이지인 경우 이동
        const newUrl = `/en${currentUrl}`;
        window.location.href = newUrl;
      }
    });
  }
});
